import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" {...props}><path fillRule="nonzero" d="M7.988 5.257L14.875 13 16 11.994 8 3l-8 8.994L1.125 13z" /></svg>);